import {
  ORG_LOOKUP_API_KEY,
  ORG_LOOKUP_API_URL,
  ORG_WHITELIST,
} from "./constants";

const BLACKLIST_ORGANISATION = ["showcase"];

export default async function fetchOrganisations() {
  const response = await fetch(`${ORG_LOOKUP_API_URL}/organisations`, {
    headers: {
      authorization: ORG_LOOKUP_API_KEY ? `Bearer ${ORG_LOOKUP_API_KEY}` : "",
    },
  });

  if (!response.ok) {
    throw new Error(response.statusText);
  }

  const organisations = (await response.json()) as string[];

  return organisations.filter((organisation) => {
    if (BLACKLIST_ORGANISATION.includes(organisation)) {
      return false;
    }
    if (ORG_WHITELIST.length > 0) {
      return ORG_WHITELIST.includes(organisation);
    }
    return true;
  });
}
